import { makeObservable, observable, action, computed, runInAction } from 'mobx';

import CourseService from 'src/services/course';
import ModuleService from 'src/services/module';
import CourseError from 'src/services/error/models/course';
import { ErrorToast } from 'src/libs/toast';

import PurchaseAlertViewModel from 'src/components/PurchaseAlert/viewModel';
import MainCardViewModel from './components/MainCard/viewModel';
import SectionTabsViewModel from './components/SectionTabs/viewModel';
import InfoSectionViewModel from './components/InfoSection/viewModel';
import ChapterSectionViewModel from './components/ChapterSection/viewModel';
import CommentSectionViewModel from './components/CommentSection/viewModel';

export default class CoursePageViewModel {
  @observable sectionTabsVm;
  @observable mainCardVm;
  @observable infoSecVm;
  @observable chapterSecVm;
  @observable commentSecVm;

  @observable bread = null;

  @observable isSmall = true;
  @observable purchaseAlert = new PurchaseAlertViewModel();

  constructor() {
    makeObservable(this);

    this.init();
  }

  @action
  init = () => {
    this.mainCardVm = new MainCardViewModel();
    this.sectionTabsVm = new SectionTabsViewModel();
    this.infoSecVm = new InfoSectionViewModel();
    this.chapterSecVm = new ChapterSectionViewModel();
    this.commentSecVm = new CommentSectionViewModel();
  }

  @action
  didMount = async (router) => {
    try {
      const moduleId = router.searchParams[0].get('module');
      const listId = router.searchParams[0].get('list');
      const [res, myRating, _] = await Promise.all([
        CourseService.getCourseDetail(router.params.cid),
        this.getMyRating(router.params.cid),
        this.updateModuleInfo(moduleId, listId, router)
      ]);
      runInAction(async () => {
        // TODO: change did mount func trigger in single sec page for better performance.
        const { mainCardInfo, infoSecInfo, chapterSecInfo, commentSecInfo } = res;
        this.mainCardVm.updateData(mainCardInfo);
        await Promise.all([
          this.infoSecVm.didMount({ ...infoSecInfo, myRating }),
          this.chapterSecVm.didMount(chapterSecInfo),
          this.commentSecVm.didMount(commentSecInfo)
        ]);
      });
    } catch (error) {
      CourseError.getCourseDetail(error);
      router.navigate('/', { replace: true });
    }
  }

  @action
  didUpdate = (router) => {
    if (router.location.pathname.split('/')[3] === 'info') {
      if (this.infoSecVm.quillViewModel.quill && !!this.infoSecVm.quillViewModel.value.ops) {
        this.infoSecVm.quillViewModel.setQuillContent(this.infoSecVm.description);
      }
    }
  }

  @action
  updateModuleInfo = async (moduleId, listId, router) => {
    try {
      if (!moduleId) {
        router.navigate(`/course/${router.params.cid}`, { replace: true });
        return;
      }
      const { id, title, list } = await ModuleService.getBookListByBlockId(moduleId);
      const target = list.find((el) => el.id === listId);
      if (!target) {
        router.navigate(`/course/${router.params.cid}`, { replace: true });
        return;
      }

      this.bread = [
        {
          type: 'module',
          id,
          name: title
        },
        {
          type: 'list',
          ...target
        }
      ];
    } catch (error) {
      console.log('error', error);
    }
  }

  // TODO: move to info sec vm.
  @action
  getMyRating = async (cid) => {
    try {
      const { data } = await CourseService.getMyRating(cid);
      return data.rating;
    } catch (error) {
      CourseError.getMyRating(error);
      return {};
    }
  }

  @action
  reloadAfterRating = async () => {
    try {
      const id = this.mainCardVm.id;
      const res = await CourseService.getCourseDetail(id);
      const myRating = await this.getMyRating(id);
      runInAction(() => {
        const { mainCardInfo, infoSecInfo } = res;
        this.mainCardVm.updateData(mainCardInfo);
        this.infoSecVm.updateData({ ...infoSecInfo, myRating });
      });
    } catch (error) {
      CourseError.getCourseDetail(error);
    }
  }

  @action
  onEnter = () => {
    this.isSmall = false;
  }

  @action
  onLeave = () => {
    this.isSmall = true;
  }

  @computed
  get secViewModels() {
    return {
      infoSecVm: this.infoSecVm,
      chapterSecVm: this.chapterSecVm,
      commentSecVm: this.commentSecVm,
      // NOTE: add for refresh.
      reloadAfterRating: this.reloadAfterRating,
      purchaseAlert: this.purchaseAlert
    };
  }
}
